import React, { useEffect } from 'react'
import { Provider, useDispatch } from 'react-redux';
import { setMaterial } from '../../../redux/materialSlice';
import { setConfig, setSteps } from '../../../redux/walkthroughPreviewSlice';
import PreviewHeader from './PreviewHeader';
import StepViewer from './StepViewer';
import { setProfileData } from '../../../redux/profileSlice';
import { getValue } from '../utils/tools';

const PublishedContentView = ({ material, current_user }) => {
  const dispatch = useDispatch();
  const defaultColors = {
    background: '#F6F8F9',
    config: material?.config
  };
  const baBGColor = getValue(defaultColors, 'ba', 'baHeaderColor');
  const previewSurfaceStyle = {
    '--path-bottom-bg': baBGColor || '#F6F8F9',
    '--path-bottom-bg-end': baBGColor || '#F6F8F9'
  };

  useEffect(() => {
    dispatch(setMaterial(material));
    dispatch(setSteps(material.data));
    dispatch(setConfig(material.config));
    dispatch(setProfileData(current_user));
  }, []);

  return (
    <>
      <div className="un-path-public-page" style={previewSurfaceStyle}>
        <PreviewHeader />
        <StepViewer />
      </div>
    </>
  )
}

export default PublishedContentView
